import { useEffect, useState } from 'react';
import { usePrevious } from 'react-use';

import { WorkerStatusTypesLookup } from '@eluve/graphql-types';

import { useAppointmentActivity } from './useAppointmentActivity';
import { useAppointmentStatus } from './useAppointmentStatus';
import { SUMMARY_TAB, useAppointmentTabNav } from './useAppointmentTabNav';

export const useListenForAppointmentEnd = () => {
  const { isSummarizationInProgress, latestSummaryStatus } =
    useAppointmentActivity();
  const { setTab } = useAppointmentTabNav();
  const appointmentStatus = useAppointmentStatus();
  const prevAppointmentStatus = usePrevious(appointmentStatus);
  const prevLatestSummaryStatus = usePrevious(latestSummaryStatus);

  const wasSummarizationInProgress = usePrevious(isSummarizationInProgress);
  const [hasAppointmentTransitioned, setHasAppointmentTransitioned] =
    useState(false);

  // Detect the transition from ACTIVE to COMPLETED
  useEffect(() => {
    if (
      prevAppointmentStatus === 'ACTIVE' &&
      appointmentStatus === 'COMPLETED'
    ) {
      setHasAppointmentTransitioned(true);
    }
  }, [appointmentStatus, prevAppointmentStatus]);

  // Switch to summary tab when generation starts or when immediately fails
  useEffect(() => {
    if (!hasAppointmentTransitioned) return;

    const startedGenerating =
      isSummarizationInProgress && !wasSummarizationInProgress;

    const showSummary =
      (startedGenerating ||
        latestSummaryStatus === WorkerStatusTypesLookup.FAILED) &&
      prevLatestSummaryStatus !== latestSummaryStatus;

    if (showSummary) {
      setTab(SUMMARY_TAB);
      setHasAppointmentTransitioned(false);
    }
  }, [
    hasAppointmentTransitioned,
    isSummarizationInProgress,
    latestSummaryStatus,
    prevLatestSummaryStatus,
    setTab,
    wasSummarizationInProgress,
  ]);
};
